import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import Spinner from './../../../spinner/spinner';
import { getRevivalInfo } from '../queries/queries';
import { ErrorBoundary } from "../../../errorBoundary/errorBoundary";
import pluralize from 'pluralize';
import { revivalPhaseCountdown } from "../../../../utilities/churchRevival";
import moment from 'moment-timezone';

class DailyHeader extends Component {
  get phaseTitleMapping() {
    return {
      0: (revival) => `Before ${revival.title}`,
      1: (revival) => {
        const daysCount = revivalPhaseCountdown({ phase: 1, startDate: this.props.revivalStartDate }, moment.unix(this.props.periodEndTime));
        return(
          `Preparation - ${pluralize('Day', daysCount, true)} to ${revival.title}`
        );
      },
      2: (revival) => `Day ${revival.phaseDayNumber} of ${revival.title}`,
      3: (revival) => `Day ${revival.phaseDayNumber} of non-Event mode`
    }
  }

  render() {
    const { data: { loading, statistics } } = this.props;

    if (loading) {
      return <Spinner />;
    } else if (this.props.hasError) {
      return null;
    } else {
      const { revivalInfo } = statistics.churchManager;
      return <h2 className="stress">{this.phaseTitleMapping[revivalInfo.phase](revivalInfo)}</h2>;
    }
  }
}

export default compose(
  graphql(getRevivalInfo, { options: { fetchPolicy: 'cache-and-network' } }), ErrorBoundary
)(DailyHeader);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/dailyHeader.js